/**
 * Top-nav doorway for Recipes / Menu Builder.
 * Label keeps the name people already look for.
 * Tooltip is the business case — not a job line in the tab, and not a “we shipped” badge.
 */

export const MENU_BUILDER_NAV_LABEL = 'Menu Builder'

export const MENU_BUILDER_NAV_TOOLTIP =
  'Cost dishes you already sell and see the GP — so you know which plates make money when supplier prices change.'
